import _ from 'lodash';

const getFlag = (flag) => {
  try {
    return require(`../assets/images/flags/${ flag }.svg`).default;
  } catch (error) {
    return require('../assets/images/flags/WORLDWIDE.svg').default;
  }
};

const toRoman = (number) => {
  const romans = {
    M: 1000,
    CM: 900,
    D: 500,
    CD: 400,
    C: 100,
    XC: 90,
    L: 50,
    XL: 40,
    X: 10,
    IX: 9,
    V: 5,
    IV: 4,
    I: 1
  };
  let roman = '';
  let i;
  if (number === 0) {
    return '';
  }

  for (i in romans) {
    while (number >= romans[i]) {
      roman += i;
      number -= romans[i];
    }
  }
  return roman;
};

const formatAmountToFixed = (number, divisor = 100, showZero = false) => {
  if (number !== 0 && _.isInteger(number) || showZero) {
    return (number / divisor).toFixed(2);
  }

  return '-';
};

const formatAmount = (number, showZero = false) => {
  if (number > 0 && _.isInteger(number) || showZero) {
    return (number / 100);
  }

  return '-';
};

const objectToQuery = (object, prefix='', removeZero=true) => {
  const emptyFiltered = _.omitBy(object, value => (removeZero && value === 0) || value === '' || value === -1);

  if (prefix === ''){
    return new URLSearchParams(emptyFiltered).toString();
  }
  let prefixedString = '?';
  // eslint-disable-next-line no-unused-vars
  let index = 0;
  for (const key of Object.keys(emptyFiltered)){
    prefixedString=`${ prefixedString }${ index !== 0 ? '&' : '' }${ prefix }[${ key }]=${ emptyFiltered[key] }`;
    index +=1;
  }
  return prefixedString;
};

const checkMarketTypeCode = (selectedNumbers) => {
  let code = 600;
  const bonusNumbers = _.filter(selectedNumbers, { type: 'bonus' });
  const starNumbers = _.filter(selectedNumbers, { type: 'star' });
  const normalNumbers = _.filter(selectedNumbers, { type: 'ball' });

  if (normalNumbers.length === selectedNumbers.length){
    code = 500;
  } else if (starNumbers.length === selectedNumbers.length){
    code = 700;
  } else if (bonusNumbers.length > 0 && normalNumbers.length !== selectedNumbers.length){
    code = 800;
  }
  return code;
};

const betsToBetslipFormat = (bets) => {
  try {
    const b = [];
    for (const bet of bets){
      if (bet.productType === 'sport'){
        const payload = {
          eventCode: bet.eventCode,
          providerCode: 1,
          odds: bet.odds,
          marketOutcomeCode: +(bet.marketOutcomeCode),
          marketCode: +(bet.marketCode),
          marketName: bet.marketDescription,
          jsonLabel: bet.jsonLabel,
          stake: bet.stake / 100 || 1,
          tournamentName: bet.tournament.name,
          tournament: bet.tournamentGroup.longName,
          datetime: bet.startTime * 1000,
          sport: bet.sport.name,
          outcome: bet.name,
          eventName: bet.eventName
        };
        b.push(payload);
      } else if (bet.productType === 'numbers'){
        const typeCode = checkMarketTypeCode(JSON.parse(bet.jsonLabel));
        const payload ={
          eventCode: bet.eventCode,
          eventName: bet.eventName,
          providerCode: 1,
          odds: bet.odds,
          marketCode: +(bet.marketCode),
          marketOutcomeCode: +(bet.marketOutcomeCode),
          marketName: bet.name,
          tournamentName: bet.tournament.name,
          datetime: bet.startTime * 1000,
          sport: 'lotto',
          type: 'numbers',
          country: bet.tournamentGroup.longName,
          prediction: bet.prediction,
          selectedNumbers: JSON.parse(bet.jsonLabel),
          jsonLabel: JSON.parse(bet.jsonLabel),
          permutationsCount: bet.prediction.permutationsCount,
          productType: 4,
          stake: bet.stake / 100 || 1,
          numbersToPredictCount: typeCode !== 700 ? bet.prediction.numbersToPredictCount : bet.prediction.bonusToPredictCount,
          sameBallset: bet.numberBonus?.sameBallset,
          market: {
            name: bet.marketName,
            code:+(bet.marketCode),
            specifiers: [{ value: typeCode !== 700 ? bet.prediction.numbersToPredictCount : bet.prediction.bonusToPredictCount }],
            typeCode,
            outcomes:[{ code: +(bet.marketOutcomeCode), value: bet.odds }]
          }
        };
        b.push(payload);
      } else {
        const label = JSON.parse(bet.jsonLabel);

        let marketTypeId = 1;

        if (bet.prediction && bet.prediction.numbersToPredictCount > 1){
          if (bet.prediction.numbersToPredictCount === 2){
            marketTypeId = 4;
          } else if (bet.prediction.numbersToPredictCount === 3){
            marketTypeId = 6;
          } else if (bet.prediction.numbersToPredictCount === 4){
            marketTypeId = 7;
          }
        }
        let payload ={};

        if (!bet.prediction){
          payload= {
            eventCode: bet.eventCode,
            odds: bet.odds,
            marketOutcomeCode: +(bet.marketOutcomeCode),
            marketCode: +(bet.marketCode),
            marketName: bet.marketDescription.toLowerCase(),
            marketDetails: { code: +(bet.marketCode), marketTypeId },
            tournamentName: bet.tournament.name,
            datetime:  bet.startTime * 1000,
            sport: 'racing',
            outcome: label.competitor,
            eventName: bet.meetingName,
            genericName: bet.marketDescription,
            horseType: 'FO',
            type: 'racing',
            country: bet.tournamentGroup.longName,
            productType: 2,
            jsonLabel: label,
            startNo: label.id,
            raceNo:  bet.eventName.split(' ')[1],
            oddsType: 3,
            stake: bet.stake / 100 || 1,
            racingType: 'horses'
          };
        } else {

          payload= {
            eventCode: bet.eventCode,
            odds: bet.odds,
            marketOutcomeCode: +(bet.marketOutcomeCode),
            marketCode: +(bet.marketCode),
            marketName: bet.marketDescription.toLowerCase(),
            marketDetails: { code: +(bet.marketCode), marketTypeId },
            tournamentName: bet.tournament.name,
            datetime:  bet.startTime * 1000,
            sport: 'racing',
            outcome: bet.prediction?.numbersToPredictCount > 1 ? bet.selectionType : label.competitor,
            eventName: bet.meetingName,
            genericName: bet.marketDescription,
            horseType: 'FO',
            type: 'racing',
            country: bet.tournamentGroup.longName,
            productType: 2,
            jsonLabel: label,
            startNo: label.id,
            ...(bet.prediction && bet.prediction?.numbersToPredictCount > 1 && { horsePosition: _.map(label, (value) => value) }),
            raceNo:  bet.eventName.split(' ')[1],
            permutationsCount: bet.prediction?.permutationsCount || 1,
            ...(bet.prediction && { prediction: {
              numbersToPredictCount: bet.prediction.numbersToPredictCount,
              anyNumbers: bet.prediction.anyNumbers,
              rankedNumbers:bet.prediction.rankedNumbers || [],
              inOrder: false
            } }),
            ...(bet.prediction && bet.prediction.numbersToPredictCount > 1 &&
          { orderedPosition: label }),
            oddsType: bet.prediction && bet.prediction?.numbersToPredictCount > 1 ? 2 : 3,
            ...(bet.prediction && bet.prediction.numbersToPredictCount > 1 && { selectionType: bet.selectionType }),
            predictionCount:bet.prediction ? bet.prediction?.permutationsCount : 1,
            stake: bet.stake / 100 || 1,
            racingType: 'horses'
          };
        }


        b.push(payload);
      }
    }
    return b;
  } catch (e) {
    return null;
  }
};

const checkError = (e) => {
  try {
    let message = '';
    const errors = e.validation;
    let index = 1;
    for (const field of Object.keys(errors)){
      for (const type of Object.keys(errors[field])){
        if (errors[field][type].message){
          message += `${ index } -` + ' ' + errors[field][type].message + '\n';
          index+=1;
        }


        if (Object.keys(errors[field][type]) && !errors[field][type].message){
          for (const number of Object.keys(errors[field][type])){
            if (number && errors[field][type][number].message){
              message += `${ index } -` + ' ' + errors[field][type][number].message + '\n';
              index+=1;
            }

            for (const error of Object.keys(errors[field][type][number])){
              if (error && errors[field][type][number][error]?.message){
                message += `${ index } -` + errors[field][type][number][error]?.message + '\n' || '';
                index+=1;
              }
            }
          }
        }
      }
    }
    return message;
  } catch (error) {
    return 'Oops! Something went wrong.';
  }
};

const factorial = (number) => {
  if (number === 0 || number === 1)
    return 1;

  for (let i = number - 1; i >= 1; i--) {
    number *= i;
  }
  return number;
};

const getNumberOfCombinations = (selectedNumbers, numbersToPredictCount, inOrder=false) => {
  if (!inOrder){
    return Math.round(factorial(selectedNumbers.length) / (factorial(
      selectedNumbers.length - (+numbersToPredictCount)) * factorial(+numbersToPredictCount)));
  }
  return Math.round(factorial(selectedNumbers.length) / factorial(
    selectedNumbers.length - (+numbersToPredictCount)));
};

const getParams = (value) => {

  if (value === 'SESSIONID'){
    return localStorage.getItem('tillSession');
  } else if (value === 'TILLID' || value==='AUTOSHOPID'){
    return localStorage.getItem('tillId');

  }

  return null;
};

const getParametersTemplate = (array) => {
  const newValues = _.map(array, (param) => {
    if (param.name === 'session_id'){
      return { transactionParameterTemplate: param.id, value: localStorage.getItem('tillSession') };
    } else if (param.name === 'till_code_path'){
      return { transactionParameterTemplate: param.id, value: localStorage.getItem('codePath') };
    }

    return { transactionParameterTemplate: param.id };
  });
  return newValues;
};

export {
  getFlag,
  toRoman,
  formatAmount,
  formatAmountToFixed,
  objectToQuery,
  betsToBetslipFormat,
  checkError,
  factorial,
  getNumberOfCombinations,
  getParams,
  getParametersTemplate
};
